import { render, staticRenderFns } from "./PersonListProvider.vue?vue&type=template&id=4c790311&scoped=true&"
import script from "./PersonListProvider.vue?vue&type=script&lang=ts&"
export * from "./PersonListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c790311",
  null
  
)

export default component.exports